// tslint:disable: completed-docs
export const NAMESPACE = 'CancellationForm';

// actions
export const ACTION_TERMINATE_CONTRACT = `${NAMESPACE}/ACTION_TERMINATE_CONTRACT` as const;
export const ACTION_TERMINATE_CONTRACT_SUCCESS = `${NAMESPACE}/ACTION_TERMINATE_CONTRACT_SUCCESS` as const;
export const ACTION_TERMINATE_CONTRACT_ERROR = `${NAMESPACE}/ACTION_TERMINATE_CONTRACT_ERROR` as const;
export const ACTION_GET_CAPTCHA = `${NAMESPACE}/ACTION_GET_CAPTCHA` as const;
export const ACTION_GET_CAPTCHA_SUCCESS = `${NAMESPACE}/ACTION_GET_CAPTCHA_SUCCESS` as const;
export const ACTION_GET_CAPTCHA_ERROR = `${NAMESPACE}/ACTION_GET_CAPTCHA_ERROR` as const;

// urls and api related constants
export const TERMINATE_CONTRACT_API = 'https://api.vodafone.de/public/v2/terminateContract';
export const GET_CAPTCHA_API = 'https://api.vodafone.de/public/v2/captcha';
export const ERROR_PAGE = 'https://eweb8.vfd2-testnet.de/cancellation-error.html';
export const X_API_KEY = 'a3Q3g2zXQfDaow9Q8i24qeHXf504e2cL';
export const CAPTCHA_BLOB = 'blob';

// Headers
export const HEADER_IMAGE = 'image/jpeg';
export const HEADER_AUDIO = 'audio/wav';
export const HEADER_CAPTCHA = 'x-captcha';
export const HEADER_CAPTCHA_HASH = 'X-Captcha-Hash';
export const HEADER_CAPTCHA_ANSWER = 'X-Captcha-Answer';
export const HEADER_CAPTCHA_API_KEY = 'x-api-key';
export const HEADER_CAPTCHA_ACCEPT_LANGUAGE = 'Accept-Language';
export const HEADER_CAPTCHA_ACCEPT_LANGUAGE_DE = 'DE';

// form element references
export const BUTTON_SEND_FORM = 'sendFormBtn';
export const BUTTON_CAPTCHA_REFRESH = 'captchaRefreshBtn';
export const BUTTON_PLAY_AUDIO = 'playAudioBtn';
export const BUTTON_TEXT_PRINT = 'Seite speichern';
export const BUTTON_ICON_PLAY = 'play-circle';
export const BUTTON_ICON_REFRESH = 'refresh';
export const BUTTON_ICON_DOWNLOAD = 'download';
export const BUTTON_EVENT_CLICK = 'click';
export const BUTTON_ELEMENT_TYPE = 'button';

// html ids and classes
export const INPUT_FIRST_NAME = 'first-name';
export const INPUT_LAST_NAME = 'last-name';
export const INPUT_STREET = 'street';
export const INPUT_HOUSE_NUMBER = 'house-number';
export const INPUT_POSTAL_CODE = 'postal-code';
export const INPUT_CITY = 'city';
export const INPUT_EMAIL = 'email';
export const INPUT_CUSTOMER_NUMBER = 'customer-number';
export const INPUT_CONTRACT_NUMBER = 'contract-number';
export const INPUT_TERMINATION_DATE = 'termination-date';
export const INPUT_NOTE = 'note';
export const INPUT_CAPTCHA_RESULT = 'captcha-result';
export const CONTAINER_CANCELLATION_FORM = 'cancellation-form-container';
export const CONTAINER_RESULT_PAGE = 'result-page-container';
export const CONTAINER_CAPTCHA = 'captcha-container';
export const CONTAINER_FIRST_NAME = 'container-firstname';
export const CONTAINER_LAST_NAME = 'container-lastname';
export const CONTAINER_STREET = 'container-street';
export const CONTAINER_HOUSE_NUMBER = 'container-housenumber';
export const CONTAINER_POSTAL_CODE = 'container-postal-code';
export const CONTAINER_CITY = 'container-city';
export const CONTAINER_EMAIL = 'container-email';
export const CONTAINER_CUSTOMER_NUMBER = 'container-customer-number';
export const CONTAINER_CONTRACT_NUMBER = 'container-contract-number';
export const CONTAINER_TERMINATION_DATE = 'container-termination-date';
export const CONTAINER_NOTE = 'container-note';
export const CONTAINER_CAPTCHA_REFRESH = 'captcha-refresh';
export const CONTAINER_CAPTCHA_IMAGE = 'captcha-image-container';
export const CONTAINER_CAPTCHA_AUDIO = 'captcha-audio';
export const CONTAINER_BUTTON_SEND_FORM = 'send-form';
export const CONTAINER_BUTTON_NEW_CAPTCHA = 'new-captcha';
export const CONTAINER_BUTTON_PRINT_TO_PDF = 'print';
export const CONTAINER_FULL_NAME_VALIDATED = 'full-name-validated';
export const CONTAINER_FULL_ADDRESS_VALIDATED = 'full-address-validated';
export const CONTAINER_EMAIL_VALIDATED = `${INPUT_EMAIL}-validated`;
export const CONTAINER_CUSTOMER_NUMBER_VALIDATED = `${INPUT_CUSTOMER_NUMBER}-validated`;
export const CONTAINER_CONTRACT_NUMBER_VALIDATED = `${INPUT_CONTRACT_NUMBER}-validated`;
export const CONTAINER_TERMINATION_DATE_VALIDATED = `${INPUT_TERMINATION_DATE}-validated`;
export const CONTAINER_NOTE_VALIDATED = `${INPUT_NOTE}-validated`;
export const CONTAINER_TIMESTAMP = 'timestamp';
export const CONTAINER_LOADING_SPINNER = 'loading-spinner';
export const CONTAINER_CAPTCHA_RESULT = 'captcha-result-container';
export const CAPTCHA_IMAGE_ELEMENT = 'captcha-image';
export const CAPTCHA_AUDIO_ELEMENT = 'captcha-audio-element';

// placeholders and texts
// eslint-disable-next-line max-len
export const PLACEHOLDER_NOTE = 'Teil uns bitte mit, welches Produkt bzw. welchen Tarif oder welche Option Du kündigen möchtest. Und was der Grund Deiner Kündigung ist.';
export const VALUE_SEND_FORM_BUTTON = 'Jetzt kündigen';
export const ASAP = 'frühestmöglich';

// tracking

/**
 * Site Structure coming from CMS (Navigation) - personal details
 */
export const ADDITIONAL_CMS_SITE_STRUCTURE_PERSONAL_DETAILS = ['privatkunden', 'mobilfunk', 'contract cancellation', 'personal details'];

/**
 * Site Structure coming from CMS (Navigation) - default
 */
export const ADDITIONAL_CMS_SITE_STRUCTURE = ['privatkunden', 'mobilfunk', 'contract cancellation'];
/**
 * Site Structure coming from CMS (Navigation) - confirmation
 */
export const ADDITIONAL_CMS_SITE_STRUCTURE_CONFIRMATION = ['privatkunden', 'mobilfunk', 'contract cancellation', 'confirmation'];

/**
 * PageType
 */
export const TRACKING_PAGE_TYPE = 'content';

/**
 * Tracking form name
 */
export const TRACKING_OFORM_NAME = 'contract cancellation';

/**
 * Tracking form type
 */
export const TRACKING_OFORM_TYPE = 'cancellation funnel';

/**
 * Tracking form step 1
 */
export const TRACKING_OFORM_FORM_STEP_ONE = '1';

/**
 * Tracking form step 2
 */
export const TRACKING_OFORM_FORM_STEP_TWO = '2';

/**
 * Tracking form step name - personal details
 */
export const TRACKING_OFORM_FORM_STEP_NAME_PERSONAL_DETAILS = 'personal details';

/**
 * Tracking form step name- confirmation
 */
export const TRACKING_OFORM_FORM_STEP_NAME_CONFIRMATION = 'confirmation';

/**
 * Tracking form status - start
 */
export const TRACKING_OFORM_FORM_STATUS_START = ['start'];

/**
 * Tracking form status - success
 */
export const TRACKING_OFORM_FORM_STATUS_SUCCESS = ['end', 'success'];

/**
 * Tracking form status - failure
 */
export const TRACKING_OFORM_FORM_STATUS_FAILURE = ['end', 'failure'];

/**
 * Tracking error action
 */
export const DISPLAYED_TEXT = 'displayed';

/**
 * Tracking error action
 */
export const VALIDATION_TEXT = 'validation';

/**
 * Tracking error action
 */
export const CAPTCHA_TEXT = 'captcha';

/**
 * Tracking error message
 */
export const CAPTCHA_ERROR_MESSAGE = 'Ups! Da ist etwas schiefgelaufen.';
